import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendConversionEvent } from '../utils/analytics';

const SERVICE_ROUTES = ['/car-loans', '/personal-loans', '/commercial-car-loans', '/business-finance', '/commercial-asset-finance'];
const CALCULATOR_ROUTE_MARKERS = ['/calculator', '/calculators', '-calculator'];

export default function ConversionAnalyticsTracker() {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname + location.search);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    const currentPath = location.pathname + location.search;

    if (previousPath !== currentPath) {
      const wasServicePage = SERVICE_ROUTES.some((route) => previousPath.startsWith(route));
      const fromCalculator = CALCULATOR_ROUTE_MARKERS.some((marker) => previousPath.includes(marker));
      const toApply = currentPath.startsWith('/apply');

      if (wasServicePage) {
        sendConversionEvent({
          event_type: 'service_page_exit',
          event_name: 'service_page_exit',
          route: previousPath,
          destination: currentPath,
          label: 'service_page_exit',
        });
      }

      if (fromCalculator && toApply) {
        sendConversionEvent({
          event_type: 'calculator_progression',
          event_name: 'calculator_to_apply_progression',
          route: previousPath,
          destination: currentPath,
          label: 'calculator_to_apply',
        });
      }

      previousPathRef.current = currentPath;
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const actionNode = target.closest('a,button');
      if (!actionNode) return;
      const anchorNode = target.closest('a');

      const testId = actionNode.getAttribute('data-testid') || '';
      const explicit = actionNode.getAttribute('data-analytics-cta') === 'true';
      if (!explicit && !testId.includes('cta')) return;

      const href = anchorNode?.getAttribute('href') || (actionNode.tagName.toLowerCase() === 'a' ? actionNode.getAttribute('href') || '' : '');
      const label = (actionNode.getAttribute('data-analytics-label') || actionNode.textContent || '').trim().slice(0, 120);

      sendConversionEvent({
        event_type: 'cta_click',
        event_name: 'cta_click_by_route',
        route: location.pathname + location.search,
        destination: href,
        label,
      });
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [location.pathname, location.search]);

  return null;
}
